import React, { useEffect, useState } from "react";
import SendClaim from "hooks/dataSenders/sendClaim";

import { API_URL } from "utils/ApiUrl";
import { toast } from "react-toastify";
import axios from "axios";
import Loader from "utils/loader";
import useWeb3 from "hooks/useWeb3";
import { useWeb3React } from "@web3-react/core";
import ClaimButton from "./claimButton";
import Sucessmodal from "utils/SuccessModal";

export function ipfsToHttp(ipfsUrl, gatewayBase) {
  if (!ipfsUrl || typeof ipfsUrl !== "string") return ipfsUrl;

  // Already a normal URL or relative path
  if (
    ipfsUrl.startsWith("http://") ||
    ipfsUrl.startsWith("https://") ||
    ipfsUrl.startsWith("/")
  ) {
    return ipfsUrl;
  }

  const gateway =
    gatewayBase ||
    process.env.REACT_APP_IPFS_GATEWAY ||
    "https://ipfs.io/ipfs/";

  // Normalize `ipfs://...`
  let rest = ipfsUrl;
  if (rest.startsWith("ipfs://")) rest = rest.slice("ipfs://".length);
  if (rest.startsWith("ipfs/")) rest = rest.slice("ipfs/".length);

  // `rest` is now like: <cid>/<path> OR <cid>
  const base = gateway.endsWith("/") ? gateway : `${gateway}/`;
  return `${base}${rest}`;
}

const NftMainCard = ({
  userNft,
  user,
  fetchUsersNFTs,
  setClaiming,
  setLoading,
}) => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const targetTime = userNft?.nextClaimedAt;

  const [showClaim, setShowClaim] = useState(false);
  const [resolvedThumbnail, setResolvedThumbnail] = useState(null);
  const [showClaimSuccessModal, setShowClaimSuccessModal] = useState(false);

  // const amount1 = userNft?.claimAmount;
  // let amount2 = parseFloat(amount1.toFixed(6));
  // const amount = web3.utils.toWei(amount2.toString(), "mwei");
  // console.log("Amount in wei: ", amount?.toString());

  const tokenId = userNft?.nftId;
  // const targetTime = "2025-01-18T15:15:28.942Z";

  const { claim } = SendClaim();

  const getSignature = async () => {
    await fetchUsersNFTs();

    const accessToken = window.localStorage.getItem("accessToken");
    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}/claims/generate-claim`,
        {
          tokenId,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "content-type": "application/json",
          },
        }
      );
      console.log(
        response?.data?.data?.nextClaimedAt,
        response?.data?.data?.amount,
        response?.data?.data?.signedKey,
        response?.data?.data?.deadline,
        "dataaa"
      );

      console.log("Signature for Claim Generated!");
      return response?.data?.data;
    } catch (error) {
      if (error?.response) {
        console.log("Error during claim request response: " + error?.message);
        toast.error("Error during claim request: " + error?.message);
      } else {
        console.log("Error during claim request: " + error?.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const generateClaim = async (
    tokenId,
    amount,
    nextClaimedAt,
    deadline,
    signature
  ) => {
    try {
      setClaiming(true);
      console.log(
        "claiming with data : ",
        tokenId,
        amount,
        nextClaimedAt,
        deadline,
        signature
      );
      const contractResponse = await claim(
        tokenId,
        amount,
        nextClaimedAt,
        deadline,
        signature
      );

      if (contractResponse) {
        try {
          const accessToken = window.localStorage.getItem("accessToken");
          const response = await axios.post(
            `${API_URL}/claims/add-claims`,
            { transactionHash: contractResponse.transactionHash },
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
              },
            }
          );
          await fetchUsersNFTs();
          console.log("Sending transactionHash", response?.data);
        } catch (error) {
          console.log(
            "Error during claim transaction response: " + error?.message
          );
          // toast.error("Error during claim transaction: " + error?.message);
        }
        toast.success("Claim successful!");
        setShowClaimSuccessModal(true);
      }
    } catch (error) {
      console.log("Error during claim: " + error.message);
      toast.error("Something went wrong during claim!", error);
    } finally {
      setClaiming(false);
    }
  };

  const handleClaimClick = async () => {
    if (account) {
      if (account?.toLowerCase() == user?.walletAddress) {
        if (!tokenId) {
          toast.error("NftId missing");
          return;
        }
        const res = await getSignature();
        console.log(res, "payloadddd 222");

        if (res) {
          console.log(
            tokenId,
            res?.amount,
            res?.nextClaimedAt,
            res?.deadline,
            res?.signedKey,
            "contract payloaddd"
          );

          try {
            await generateClaim(
              tokenId,
              res?.amount,
              res?.nextClaimedAt,
              res?.deadline,
              res?.signedKey
            );
          } catch (error) {
            console.error("Error in handleClaimClick: ", error.message);
            toast.error("Something went wrong during the claim process!");
          }
        }
        console.log(
          tokenId,
          res.amount,
          res?.nextClaimedAt,
          res?.deadline,
          res?.signedKey,
          "contract payloaddd 11111"
        );
      } else {
        console.log("Wrong wallet addressssssss.");
        toast.error(
          "Wrong wallet address. Please connect wallet associated with the account"
        );
        return;
      }
    } else {
      toast?.error("Connect your wallet");
      return;
    }
  };

  useEffect(() => {
    if (!userNft?.isMoreThan30Days || userNft?.claimAmount == 0)
      setShowClaim(false);
    else setShowClaim(true);
    // setShowClaim(userNft?.isMoreThan30Days);
  }, [userNft]);

  // Resolve `thumbnailImage` when it actually points to IPFS metadata (JSON) instead of an image.
  useEffect(() => {
    let cancelled = false;

    async function resolveThumb(nft) {
      const raw = nft?.thumbnailImage;
      if (!raw || typeof raw !== "string") return null;

      // If it already looks like a normal image URL, keep it.
      if (
        raw.startsWith("http://") ||
        raw.startsWith("https://") ||
        raw.startsWith("/")
      ) {
        return raw;
      }

      // First try to treat it as a direct IPFS asset.
      const direct = ipfsToHttp(raw);

      // Common pattern: folder CID where metadata is stored under filename "1"
      const metadataCandidate = raw.endsWith("/") ? `${raw}1` : raw;
      const metadataUrl = ipfsToHttp(metadataCandidate);

      try {
        const res = await fetch(metadataUrl, { cache: "no-store" });
        const ct = (res.headers.get("content-type") || "").toLowerCase();
        if (
          res.ok &&
          (ct.includes("application/json") || ct.includes("text/plain"))
        ) {
          const json = await res.json().catch(() => null);
          const image = json?.image;
          if (image && typeof image === "string") return ipfsToHttp(image);
        }
      } catch (e) {
        // ignore and fall back to direct
      }

      return direct;
    }

    async function run() {
      const resolved = await resolveThumb(userNft);
      if (!cancelled) setResolvedThumbnail(resolved);
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [userNft?.thumbnailImage]);

  return (
    <>
      <Sucessmodal
        show={showClaimSuccessModal}
        handleClose={() => setShowClaimSuccessModal(false)}
      />
      <div className="maincarddiv" style={{ cursor: "pointer" }}>
        <div className="zoom-container">
          <img
            src={resolvedThumbnail || ipfsToHttp(userNft?.thumbnailImage)}
            alt="image"
            className="imgcardddds"
          />
        </div>
        <div className="inercard_dta">
          <div className="d-flex justify-content-between">
            <h1>{userNft?.name}</h1>
            <h1>#{userNft?.nftId}</h1>
          </div>
          <p>{userNft?.location}</p>
          <div className="inercarddiv">
            <div className="toperparadivflex">
              <p className="expecteddf">Expected Rental Income</p>
              <p className="diggtits">${(userNft?.rentPerNft).toFixed(6)}</p>
            </div>
            <div className="toperparadivflex">
              <p className="expecteddf">Next Rental Income</p>
              <p className="diggtits">
                {targetTime === null && <p>Loading claim...</p>}
                <ClaimButton
                  targetTime={targetTime}
                  fetchUsersNFTs={fetchUsersNFTs}
                />
              </p>
            </div>
            {showClaim && (
              <div className="toperparadivflex">
                <p className="expecteddf">Available to claim</p>
                <p className="diggtits">
                  {/* {targetTime === null && <p>Loading claim...</p>} */}
                  <button
                    style={{
                      display: "flex",
                      padding: "4px 10px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                      borderRadius: "32px",
                      background: "#FF8A00",
                      color: "#FFF",
                      fontSize: "11px",
                      fontStyle: "normal",
                      fontWeight: 600,
                      lineHeight: "100%",
                      border: "none",
                      outline: "none",
                    }}
                    onClick={handleClaimClick}
                  >
                    {/* {timeLeft} */}
                    Claim
                  </button>
                </p>
              </div>
            )}
          </div>
          <div className="iner_mainsssss">
            <div className="cardds">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
              >
                <path
                  d="M12.3498 5.88614H2.29929C2.11366 5.88614 1.9646 6.0366 1.9646 6.22082V16.2713C1.9646 16.4569 2.11507 16.606 2.29929 16.606H12.3498C12.5354 16.606 12.6844 16.4555 12.6844 16.2713V6.22082C12.6844 6.0352 12.534 5.88614 12.3498 5.88614ZM12.0151 15.9366H2.63538V6.55551H12.0151V15.9352V15.9366ZM12.6788 3.81051C12.6774 3.80067 12.6732 3.79223 12.6704 3.78239C12.6676 3.77114 12.6648 3.75989 12.6591 3.74864C12.6549 3.73739 12.6479 3.72754 12.6423 3.71629C12.638 3.70786 12.6338 3.69942 12.6282 3.69098C12.6155 3.6727 12.6015 3.65582 12.586 3.64035L11.5805 2.63489C11.4498 2.50411 11.2374 2.50411 11.1066 2.63489C10.9759 2.76567 10.9759 2.97801 11.1066 3.10879L11.5398 3.54192H3.10929L3.54241 3.10879C3.67319 2.97801 3.67319 2.76567 3.54241 2.63489C3.41163 2.50411 3.19929 2.50411 3.06851 2.63489L2.06304 3.64035C2.04757 3.65582 2.03351 3.6727 2.02085 3.69239C2.01522 3.70082 2.01241 3.70926 2.00679 3.7177C2.00116 3.72895 1.99413 3.73879 1.98991 3.75004C1.98569 3.76129 1.98288 3.77254 1.98007 3.78379C1.97726 3.79364 1.97304 3.80207 1.97163 3.81192C1.96741 3.83301 1.9646 3.85551 1.9646 3.87801C1.9646 3.90051 1.96741 3.9216 1.97163 3.9441C1.97304 3.95395 1.97726 3.96379 1.98007 3.97364C1.98288 3.98489 1.98569 3.99614 1.98991 4.00739C1.99413 4.01864 2.00116 4.02989 2.00679 4.03973C2.01101 4.04817 2.01522 4.0566 2.02085 4.06504C2.03351 4.08332 2.04757 4.1002 2.06304 4.11707L3.06851 5.12254C3.1346 5.18864 3.21897 5.22098 3.30476 5.22098C3.39054 5.22098 3.47632 5.18864 3.54101 5.12254C3.67179 4.99176 3.67179 4.77942 3.54101 4.64864L3.10788 4.21551H11.5412L11.108 4.64864C10.9773 4.77942 10.9773 4.99176 11.108 5.12254C11.1741 5.18864 11.2585 5.22098 11.3443 5.22098C11.4301 5.22098 11.5158 5.18864 11.5805 5.12254L12.586 4.11707C12.6015 4.1016 12.6155 4.08473 12.6282 4.06504C12.6338 4.0566 12.6366 4.04817 12.6423 4.03973C12.6479 4.02848 12.6549 4.01864 12.6591 4.00739C12.6633 3.99614 12.6662 3.98489 12.669 3.97364C12.6718 3.96379 12.676 3.95535 12.6774 3.94551C12.6816 3.92442 12.6844 3.90192 12.6844 3.87942C12.6844 3.85692 12.6816 3.83582 12.6774 3.81332L12.6788 3.81051ZM15.4632 15.0282L15.0301 15.4613V7.02801L15.4632 7.46114C15.5293 7.52723 15.6137 7.55957 15.6994 7.55957C15.7852 7.55957 15.871 7.52723 15.9357 7.46114C16.0665 7.33035 16.0665 7.11801 15.9357 6.98723L14.9302 5.98176C14.9148 5.96629 14.8979 5.95223 14.8782 5.93957C14.8698 5.93395 14.8613 5.93114 14.8529 5.92551C14.8416 5.91989 14.8318 5.91285 14.8205 5.90864C14.8093 5.90442 14.798 5.9016 14.7868 5.89879C14.7769 5.89598 14.7685 5.89176 14.7587 5.89035C14.7151 5.88192 14.6701 5.88192 14.6279 5.89035C14.618 5.89176 14.6082 5.89598 14.5998 5.89879C14.5885 5.9016 14.5773 5.90442 14.566 5.90864C14.5548 5.91285 14.5435 5.91989 14.5337 5.92551C14.5252 5.92973 14.5168 5.93395 14.5083 5.93957C14.4901 5.95223 14.4732 5.96629 14.4577 5.98176L13.4523 6.98723C13.3215 7.11801 13.3215 7.33035 13.4523 7.46114C13.583 7.59192 13.7954 7.59192 13.9262 7.46114L14.3593 7.02801V15.4613L13.9262 15.0282C13.7954 14.8974 13.583 14.8974 13.4523 15.0282C13.3215 15.1589 13.3215 15.3713 13.4523 15.5021L14.4577 16.5075C14.4732 16.523 14.4901 16.5371 14.5083 16.5497C14.5168 16.5554 14.5252 16.5582 14.5337 16.5638C14.5449 16.5694 14.5548 16.5764 14.566 16.5807C14.5773 16.5849 14.5885 16.5877 14.5998 16.5905C14.6096 16.5933 14.6194 16.5975 14.6293 16.5989C14.6504 16.6032 14.6729 16.606 14.6954 16.606C14.7179 16.606 14.739 16.6032 14.7615 16.5989C14.7713 16.5975 14.7812 16.5933 14.7896 16.5905C14.8008 16.5877 14.8121 16.5849 14.8233 16.5807C14.8346 16.5764 14.8458 16.5694 14.8557 16.5638C14.8641 16.5596 14.8726 16.5554 14.881 16.5497C14.8993 16.5371 14.9162 16.523 14.933 16.5075L15.9385 15.5021C16.0693 15.3713 16.0693 15.1589 15.9385 15.0282C15.8077 14.8974 15.5954 14.8974 15.4646 15.0282H15.4632Z"
                  fill="#FF8A00"
                />
                <path
                  d="M4.65599 10.6688H4.90208V12.4857C4.90208 12.7149 5.01458 12.8288 5.23958 12.8288C5.46458 12.8288 5.57146 12.7149 5.57146 12.4857V10.6688H6.02708C6.11005 10.6688 6.17333 10.6491 6.21692 10.6125C6.26192 10.6491 6.3238 10.6688 6.40677 10.6688H6.68521V11.8107C6.68521 12.4969 7.03114 12.84 7.72442 12.84C7.78208 12.84 7.84817 12.833 7.92271 12.8218C7.99724 12.8091 8.05911 12.7964 8.10552 12.781C8.16599 12.7599 8.20817 12.7219 8.23208 12.6657C8.25458 12.6108 8.26724 12.5475 8.26724 12.4758C8.26724 12.383 8.25317 12.3211 8.22364 12.2916C8.19552 12.2607 8.15896 12.248 8.11677 12.2508C8.08161 12.255 8.03942 12.2621 7.99302 12.2719C7.94661 12.2832 7.89317 12.2888 7.83271 12.2888C7.66536 12.2888 7.54302 12.2452 7.46849 12.1594C7.39396 12.0736 7.35599 11.9457 7.35599 11.7741V10.6702H7.92411C8.10271 10.6702 8.19271 10.5858 8.19271 10.4185C8.19271 10.2511 8.10271 10.1668 7.92411 10.1668H7.35599V9.67879C7.35599 9.45379 7.24489 9.34129 7.02411 9.34129C6.80333 9.34129 6.68661 9.45379 6.68661 9.67879V10.1668H6.40817C6.32521 10.1668 6.26192 10.1864 6.21833 10.2244C6.17333 10.1879 6.11146 10.1668 6.02849 10.1668H5.57286V10.0543C5.57286 9.87145 5.61927 9.73645 5.71208 9.64645C5.80489 9.55645 5.95395 9.50582 6.15646 9.49036L6.23099 9.48473C6.29849 9.4777 6.35052 9.44817 6.38708 9.39614C6.42224 9.34411 6.43911 9.28504 6.43771 9.21895C6.4363 9.15286 6.4138 9.09661 6.37021 9.0502C6.32802 9.00379 6.25911 8.98411 6.1663 8.99114L5.98349 9.00801C5.63333 9.04036 5.36474 9.14864 5.17911 9.33286C4.99349 9.51707 4.90067 9.7927 4.90067 10.1611V10.1668H4.65458C4.47599 10.1668 4.38599 10.2511 4.38599 10.4185C4.38599 10.5858 4.47458 10.6702 4.65458 10.6702L4.65599 10.6688ZM8.54989 9.56348C8.60192 9.58176 8.65958 9.57192 8.72427 9.53676C8.78192 9.50442 8.84239 9.47911 8.90708 9.45942C8.97177 9.43973 9.03364 9.42989 9.09411 9.42989C9.30083 9.42989 9.40489 9.5227 9.40489 9.70832C9.40489 9.78286 9.38661 9.85879 9.34864 9.93332C9.31067 10.0079 9.24739 10.0922 9.1588 10.185L8.61739 10.7532C8.5738 10.7954 8.54005 10.8389 8.51614 10.8811C8.49083 10.9247 8.47817 10.9739 8.47817 11.0316C8.47817 11.1033 8.50208 11.161 8.54989 11.206C8.59771 11.251 8.65817 11.2735 8.72989 11.2735H9.89286C10.0461 11.2735 10.1235 11.1989 10.1235 11.0485C10.1235 10.898 10.0461 10.8235 9.89286 10.8235H9.1588L9.62567 10.3411C9.75364 10.2089 9.84646 10.088 9.9013 9.97692C9.95614 9.86582 9.98427 9.75192 9.98427 9.63379C9.98427 9.43411 9.91536 9.2752 9.77755 9.15989C9.63974 9.04457 9.45271 8.98551 9.21786 8.98551C9.09974 8.98551 8.98021 9.00098 8.85927 9.03051C8.73833 9.06145 8.63005 9.10504 8.53724 9.16129C8.47255 9.20067 8.43317 9.24848 8.41911 9.30614C8.40505 9.36379 8.41067 9.41582 8.43458 9.46364C8.45989 9.51145 8.49786 9.5452 8.54989 9.56207V9.56348Z"
                  fill="#FF8A00"
                />
              </svg>
              <h2>{userNft?.area} sqft</h2>
            </div>
            <div className="cardds">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
              >
                <g clip-path="url(#clip0_818_2027)">
                  <path
                    d="M17.4475 8.91051V5.99751C17.4467 5.25637 17.152 4.54581 16.6279 4.02174C16.1038 3.49767 15.3933 3.2029 14.6521 3.20211H4.89133C4.1505 3.20338 3.44041 3.49836 2.91673 4.02238C2.39305 4.54639 2.09853 5.25668 2.09773 5.99751V8.91711C1.74934 9.07777 1.45412 9.33465 1.24684 9.65748C1.03955 9.98032 0.928837 10.3557 0.927734 10.7393V14.0441C0.928052 14.2784 1.02129 14.5029 1.18698 14.6685C1.35267 14.8341 1.57729 14.9272 1.81153 14.9273H2.83753V15.4889C2.83753 15.6083 2.88494 15.7227 2.96934 15.8071C3.05373 15.8915 3.16819 15.9389 3.28753 15.9389C3.40688 15.9389 3.52134 15.8915 3.60573 15.8071C3.69012 15.7227 3.73753 15.6083 3.73753 15.4889V14.9273H15.8185V15.4889C15.8185 15.6083 15.8659 15.7227 15.9503 15.8071C16.0347 15.8915 16.1492 15.9389 16.2685 15.9389C16.3879 15.9389 16.5023 15.8915 16.5867 15.8071C16.6711 15.7227 16.7185 15.6083 16.7185 15.4889V14.9273H17.7445C17.9787 14.927 18.2031 14.8338 18.3687 14.6683C18.5343 14.5027 18.6274 14.2783 18.6277 14.0441V10.7393C18.6268 10.3535 18.5151 9.97598 18.3059 9.65177C18.0967 9.32757 17.7988 9.07028 17.4475 8.91051ZM2.99773 5.99751C2.99821 5.49528 3.19781 5.01372 3.55277 4.65842C3.90774 4.30312 4.3891 4.10306 4.89133 4.10211H14.6521C15.1547 4.10259 15.6365 4.30243 15.9919 4.65779C16.3472 5.01314 16.5471 5.49497 16.5475 5.99751V8.72331H15.1033V7.46331C15.103 7.04882 14.9383 6.65139 14.6452 6.35824C14.3522 6.0651 13.9548 5.90019 13.5403 5.89971H11.7757C11.3612 5.90019 10.9638 6.06508 10.6706 6.3582C10.3775 6.65133 10.2126 7.04876 10.2121 7.46331V8.72331H9.33793V7.46331C9.33746 7.04876 9.17257 6.65133 8.87944 6.3582C8.58631 6.06508 8.18888 5.90019 7.77433 5.89971H6.00913C5.59521 5.90114 5.1987 6.06645 4.90635 6.35947C4.614 6.6525 4.44961 7.04939 4.44913 7.46331V8.72331H2.99773V5.99751ZM14.2051 8.72331H11.1121V7.46331C11.1123 7.28736 11.1823 7.11866 11.3067 6.99425C11.4311 6.86984 11.5998 6.79987 11.7757 6.79971H13.5403C13.7162 6.79987 13.8849 6.86985 14.0092 6.99429C14.1335 7.11872 14.2033 7.28742 14.2033 7.46331L14.2051 8.72331ZM8.43973 8.72331H5.34613V7.46331C5.34629 7.28798 5.41576 7.11983 5.5394 6.99552C5.66304 6.8712 5.83081 6.80082 6.00613 6.79971H7.77133C7.94728 6.79987 8.11598 6.86984 8.24039 6.99425C8.36481 7.11866 8.43477 7.28736 8.43493 7.46331L8.43973 8.72331ZM16.2757 14.0291H16.2685H16.2607L3.36073 14.0423C3.33682 14.0352 3.31232 14.0302 3.28753 14.0273C3.26235 14.0302 3.23746 14.0352 3.21313 14.0423H1.82773V10.7393C1.82805 10.4434 1.94573 10.1598 2.15495 9.95053C2.36418 9.74131 2.64785 9.62363 2.94373 9.62331H16.6117C16.9076 9.62363 17.1913 9.74131 17.4005 9.95053C17.6097 10.1598 17.7274 10.4434 17.7277 10.7393L17.7445 14.0273L16.2757 14.0291Z"
                    fill="#FF8A00"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_818_2027">
                    <rect
                      width="18"
                      height="18"
                      fill="white"
                      transform="translate(0.777832 0.570511)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <h2>{userNft?.bedrooms} Bed</h2>
            </div>
            <div className="cardds">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
              >
                <path
                  d="M16.1975 10.2469H16.0007V4.79758C16.0033 4.29084 15.8631 3.7935 15.5961 3.36191C15.329 2.93031 14.9457 2.58171 14.4897 2.3556C14.0336 2.12948 13.523 2.03489 13.0157 2.08253C12.5083 2.13017 12.0246 2.31815 11.6191 2.62517C11.0678 2.44198 10.4672 2.47214 9.93718 2.70962C9.40716 2.9471 8.98659 3.37448 8.7593 3.90655L8.68672 4.07785C8.6471 4.16918 8.62599 4.26738 8.62459 4.36684C8.62319 4.46629 8.64153 4.56505 8.67857 4.65744C8.7156 4.74984 8.7706 4.83407 8.84041 4.9053C8.91022 4.97653 8.99348 5.03337 9.08541 5.07256L11.9826 6.31125C12.0776 6.35155 12.1798 6.37246 12.2831 6.37275C12.4318 6.37218 12.5771 6.32864 12.7014 6.24741C12.8256 6.16619 12.9234 6.0508 12.9829 5.91529L13.0565 5.74451C13.2591 5.28399 13.3035 4.76992 13.1828 4.28178C13.0622 3.79365 12.7831 3.35864 12.3889 3.044C12.6891 2.89328 13.0231 2.8218 13.359 2.83641C13.6949 2.85103 14.0214 2.95126 14.3072 3.12747C14.5929 3.30368 14.8283 3.54997 14.9908 3.8427C15.1533 4.13542 15.2373 4.46476 15.235 4.7991V10.2469H2.91438C2.68672 10.2472 2.46846 10.3372 2.30748 10.4973C2.14649 10.6574 2.05593 10.8744 2.05566 11.1008V12.4224C2.05631 13.124 2.24892 13.8122 2.61288 14.4133C2.97684 15.0144 3.49841 15.5057 4.1217 15.8345L3.68928 16.4688C3.65977 16.5102 3.63887 16.557 3.6278 16.6065C3.61672 16.656 3.61569 16.7072 3.62477 16.7572C3.63385 16.8071 3.65286 16.8547 3.68067 16.8972C3.70849 16.9397 3.74456 16.9763 3.78677 17.0048C3.82898 17.0332 3.87648 17.053 3.92649 17.063C3.9765 17.073 4.02801 17.073 4.078 17.0629C4.128 17.0529 4.17547 17.033 4.21765 17.0045C4.25982 16.976 4.29584 16.9393 4.3236 16.8968L4.84804 16.1283C5.20313 16.2329 5.57151 16.2864 5.94188 16.2868H13.1694C13.5396 16.2863 13.9078 16.233 14.2628 16.1288L14.7867 16.8968C14.8145 16.9393 14.8505 16.976 14.8927 17.0045C14.9348 17.033 14.9823 17.0529 15.0323 17.0629C15.0823 17.073 15.1338 17.073 15.1838 17.063C15.2338 17.053 15.2813 17.0332 15.3235 17.0048C15.3657 16.9763 15.4018 16.9397 15.4296 16.8972C15.4574 16.8547 15.4765 16.8071 15.4855 16.7572C15.4946 16.7072 15.4936 16.656 15.4825 16.6065C15.4714 16.557 15.4505 16.5102 15.421 16.4688L14.9886 15.835C15.6122 15.5063 16.134 15.015 16.4981 14.4138C16.8623 13.8126 17.055 13.1242 17.0557 12.4224V11.1008C17.0554 10.8745 16.9649 10.6575 16.804 10.4975C16.6432 10.3374 16.425 10.2473 16.1975 10.2469ZM12.3511 5.44157L12.2795 5.60778L9.39056 4.37723L9.46366 4.20695C9.58501 3.92771 9.78571 3.68977 10.0411 3.52237C10.2966 3.35496 10.5956 3.26537 10.9015 3.26459C11.118 3.26493 11.3322 3.30939 11.5307 3.39522C11.9121 3.55876 12.2127 3.86606 12.3665 4.2497C12.5203 4.63334 12.5147 5.06198 12.3511 5.44157ZM16.2869 12.4224C16.2856 13.2443 15.9566 14.0321 15.3722 14.6133C14.7877 15.1945 13.9955 15.5215 13.1689 15.5229H5.94188C5.11536 15.5215 4.32308 15.1945 3.73864 14.6133C3.1542 14.0321 2.82526 13.2443 2.82391 12.4224V11.1008C2.82391 11.0765 2.83361 11.0533 2.85086 11.0361C2.86811 11.019 2.89152 11.0093 2.91592 11.0093H16.1975C16.2218 11.0095 16.245 11.0192 16.2622 11.0363C16.2793 11.0534 16.2889 11.0766 16.2889 11.1008L16.2869 12.4224Z"
                  fill="#FF8A00"
                />
                <path
                  d="M7.92735 5.95479L7.40775 6.51999C7.33496 6.60873 7.29882 6.72193 7.30674 6.83643C7.31465 6.95093 7.36602 7.05809 7.45034 7.13596C7.53465 7.21384 7.64554 7.25655 7.76031 7.25537C7.87508 7.25418 7.98506 7.20919 8.06775 7.12959L8.58795 6.56439C8.66397 6.47572 8.70259 6.36099 8.69566 6.2444C8.68874 6.12781 8.63682 6.01846 8.55084 5.93941C8.46486 5.86036 8.35155 5.81778 8.23479 5.82065C8.11803 5.82351 8.00694 5.87161 7.92495 5.95479H7.92735ZM8.94555 7.88379C8.99923 7.90898 9.05736 7.92334 9.1166 7.92602C9.17584 7.92871 9.23502 7.91968 9.29077 7.89944C9.34651 7.87921 9.39771 7.84817 9.44143 7.80811C9.48515 7.76805 9.52053 7.71975 9.54555 7.66599L9.85455 7.00239C9.90492 6.89418 9.91023 6.77039 9.86933 6.65827C9.82843 6.54614 9.74466 6.45485 9.63645 6.40449C9.52824 6.35412 9.40446 6.34881 9.29233 6.38971C9.1802 6.43061 9.08892 6.51438 9.03855 6.62259L8.72955 7.28559C8.67894 7.39357 8.67327 7.51722 8.71377 7.62938C8.75427 7.74155 8.83763 7.83305 8.94555 7.88379ZM10.5332 8.57619C10.6423 8.57608 10.7478 8.53628 10.8298 8.4642C10.9118 8.39211 10.9648 8.29266 10.979 8.18439L11.078 7.42299C11.0932 7.30459 11.0608 7.18498 10.9879 7.09046C10.915 6.99594 10.8075 6.93426 10.6892 6.91899C10.5708 6.90371 10.4511 6.93609 10.3566 7.009C10.2621 7.08192 10.2004 7.18939 10.1852 7.30779L10.0868 8.06859C10.0792 8.12721 10.0832 8.18675 10.0987 8.24381C10.1141 8.30087 10.1406 8.35433 10.1767 8.40114C10.2128 8.44794 10.2578 8.48717 10.3091 8.51659C10.3604 8.54601 10.4169 8.56503 10.4756 8.57259C10.4947 8.57496 10.5139 8.57616 10.5332 8.57619Z"
                  fill="#FF8A00"
                />
              </svg>
              <h2>{userNft?.bathrooms} Bath</h2>
            </div>
          </div>
          {/* <div className="botttom_side">
          <button>${userNft.projects.propertyPrice.toLocaleString()}</button>
        </div> */}
        </div>
      </div>
    </>
  );
};

export default NftMainCard;
